import {
  SELECT_GOV_ID_TYPE,
  GET_GOV_ID_LINK_SUCCESS,
  GET_GOV_ID_LINK_FAILURE,
  GET_PREFILL_HINT_SUCCESS,
  GET_PREFILL_HINT_FAILURE,
} from '../constants';

const defaultState = {
  govIdTypeSelected: false,
  govIdLink: null,
  govIdLinkError: null,
  prefillRedirectUrl: null,
  prefillError: null,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SELECT_GOV_ID_TYPE:
      const { type } = action.payload;
      return {
        ...state,
        govIdTypeSelected: type,
      };
    case GET_GOV_ID_LINK_SUCCESS:
      return {
        ...state,
        govIdLink: action.payload.link,
        govIdLinkError: null,
      };
    case GET_GOV_ID_LINK_FAILURE:
      return {
        ...state,
        govIdLink: null,
        govIdLinkError: action.payload.errorDetail,
      };
    case GET_PREFILL_HINT_SUCCESS:
      return {
        ...state,
        prefillRedirectUrl: action.payload.redirectUrl,
        prefillError: null,
      };
    case GET_PREFILL_HINT_FAILURE:
      return {
        ...state,
        prefillRedirectUrl: null,
        prefillError: action.payload.errorDetail,
      };
    default:
      return { ...state };
  }
};
